import React from "react";
import {
  Link,
  useNavigate,
  useParams,
  useLocation,
  Navigate,
} from "react-router-dom";
import { useQuery } from "react-query";
import moment from "moment";
import useApi from "../../../hooks/useApi";
import PolicyItemStatus, {
  activeStatus,
} from "../../../widgets/PolicyItemStatus";
import useSortableTableHeader from "../../../hooks/useSortableTableHeader";
import PoliciesTable from "./PoliciesTable";

const PoliciesExpiringNextWeekTab = () => {
  const { api, auth } = useApi();
  const { TableHeader } = useSortableTableHeader();

  const getPolicies = async () => {
    try {
      const url = `/policies/policy-items/expiring-next-week`;
      const { data } = await api.list(url);
      return data;
    } catch (error) {
      throw new Error("failed to fetch records");
    }
  };

  const { data, refetch } = useQuery(
    ["ExpiringNextWeekPolicyItems", auth],
    ({ queryKey }) => getPolicies()
  );

  return (
    <div className="table-responsive bg-white mb-3">
      <h1 className="py-2 text-center border-bottom border-2 border-primary">
        {(data && data?.length) || 0} polic
        {data && data?.length > 1 ? "ies" : "y"} expiring next week
      </h1>
      <PoliciesTable policies={data} />
    </div>
  );
};

export default PoliciesExpiringNextWeekTab;
